import { Add, Delete } from '@mui/icons-material';
import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React from 'react';

const SchemaEditor = ({ schema, onChange }) => {
  const handleAddField = () => {
    const newSchema = [...schema, { name: '', type: 'text', default: '', options: [] }];
    onChange(newSchema);
  };

  const handleRemoveField = (index) => {
    const newSchema = schema.filter((_, i) => i !== index);
    onChange(newSchema);
  };

  const handleFieldChange = (index, field, value) => {
    const newSchema = schema.map((item, i) => {
      if (i === index) {
        return { ...item, [field]: value };
      }
      return item;
    });
    onChange(newSchema);
  };

  return (
    <Box sx={{ mt: 2 }}>
      {schema.map((field, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField
              label="Название поля"
              value={field.name}
              onChange={(e) => handleFieldChange(index, 'name', e.target.value)}
              size="small"
              sx={{ flex: 1 }}
            />
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Тип</InputLabel>
              <Select
                value={field.type}
                label="Тип"
                onChange={(e) => handleFieldChange(index, 'type', e.target.value)}
              >
                <MenuItem value="text">Текст</MenuItem>
                <MenuItem value="number">Число</MenuItem>
                <MenuItem value="date">Дата</MenuItem>
                <MenuItem value="boolean">Да/Нет</MenuItem>
                <MenuItem value="select">Выбор</MenuItem>
                <MenuItem value="file">Файл</MenuItem>
                <MenuItem value="image">Изображение</MenuItem>
              </Select>
            </FormControl>
            <IconButton onClick={() => handleRemoveField(index)} color="error">
              <Delete />
            </IconButton>
          </Box>
          {/* Поле по умолчанию */}
          <Box sx={{ mt: 1, display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField
              label="Значение по умолчанию"
              value={field.default || ''}
              onChange={(e) => handleFieldChange(index, 'default', e.target.value)}
              size="small"
              sx={{ flex: 1 }}
            />
            {field.type === 'select' && (
              <TextField
                label="Варианты (через запятую)"
                value={(field.options || []).join(',')}
                onChange={(e) => handleFieldChange(
                  index,
                  'options',
                  e.target.value.split(',').map(opt => opt.trim())
                )}
                size="small"
                sx={{ flex: 1 }}
              />
            )}
          </Box>
        </Box>
      ))}
      <Button
        startIcon={<Add />}
        onClick={handleAddField}
        variant="contained"
        color="success"
        size="small"
      >
        Добавить поле
      </Button>
    </Box>
  );
};

export default SchemaEditor; 